import React, { useState } from 'react';
import axios from 'axios';
import { FaPhone, FaWeixin, FaTelegram, FaWhatsapp, FaLine } from 'react-icons/fa';
import './App.css';

function App() {
  const [formData, setFormData] = useState({
    name: '',
    phoneWhatsapp: '',
    businessType: '',
    industry: '',
    targetMarket: '',
    needDemo: '',
    socialAccount: '',
    painPoint: ''
  });

  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });
  const [activeAccordion, setActiveAccordion] = useState(null);

  const toggleAccordion = (index) => {
    setActiveAccordion(activeAccordion === index ? null : index);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleWechatCopy = async () => {
    const wechatId = 'dzt1234hu';

    try {
      await navigator.clipboard.writeText(wechatId);
      window.alert(`微信号 ${wechatId} 已复制到剪贴板`);
    } catch (error) {
      console.error('复制微信号失败:', error);
      window.alert(`复制失败，请手动复制微信号：${wechatId}`);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setMessage({ type: '', text: '' });

    try {
      // 发送到飞书机器人 - 使用卡片消息
      const feishuData = {
        msg_type: 'interactive',
        card: {
          header: {
            title: {
              tag: 'plain_text',
              content: '🎉 客番番新客户咨询'
            },
            template: 'blue'
          },
          elements: [
            {
              tag: 'div',
              text: {
                tag: 'lark_md',
                content: `**姓名：**${formData.name || '未填写'}\n**电话/微信/WS/TG/line：**${formData.phoneWhatsapp || '未填写'}\n**业务类型：**${formData.businessType || '未填写'}\n**行业：**${formData.industry || '未填写'}\n**目标市场：**${formData.targetMarket || '未填写'}\n**是否预约演示：**${formData.needDemo || '未填写'}\n**社媒账号：**${formData.socialAccount || '未填写'}\n**痛点：**${formData.painPoint || '未填写'}\n**提交时间：**${new Date().toLocaleString('zh-CN', { timeZone: 'Asia/Shanghai', hour12: false }).replace(/\//g, '-')}`
              }
            }
          ]
        }
      };

      await axios.post(
        'https://open.feishu.cn/open-apis/bot/v2/hook/ca1e09e3-7d9c-497e-aebe-9a2c5a69d5a7',
        feishuData,
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );

      setMessage({ type: 'success', text: '已发送成功，我们会尽快联系您。' });

      const TRACKING_KEY = 'generate_lead_tracked_dzt';

      if (window.gtag && !localStorage.getItem(TRACKING_KEY)) {
        window.gtag('event', 'generate_lead', {
          currency: 'USD',
          value: 0
        });

        localStorage.setItem(TRACKING_KEY, '1');
      }

      setFormData({
        name: '',
        phoneWhatsapp: '',
        businessType: '',
        industry: '',
        targetMarket: '',
        needDemo: '',
        socialAccount: '',
        painPoint: ''
      });

      // 3秒后自动隐藏成功消息
      setTimeout(() => {
        setMessage({ type: '', text: '' });
      }, 3000);
    } catch (error) {
      console.error('提交错误:', error);
      setMessage({ type: 'error', text: '发送信息时出现错误，请稍后再试。' });

      // 5秒后自动隐藏错误消息
      setTimeout(() => {
        setMessage({ type: '', text: '' });
      }, 5000);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="App">
      {/* Header */}
      <header className="header">
        <div className="logo">
          <img src="/images/logo.png" alt="客番番Logo" />
        </div>

      </header>

      {/* Hero Section */}
      <section id="home" className="hero-section">
        <div className="hero-content">
          <h1>客番番 | 海外社媒矩阵自动化管理系统</h1>
          <h2>硬件级隔离技术 × AI智能营销</h2>
          <h2>30分钟采集10万+精准客户数据</h2>
          <p>客番番是一款基于移动设备的独立安全的海外社媒矩阵管理系统，通过真机模拟环境和硬件级隔离技术，帮助企业实现多账号管理和自动化营销，保障账号安全，提升全球社媒营销效率。</p>
          <div className="hero-buttons">
            <a href="#contact" className="btn btn-primary">预约专属客户经理</a>
            <a href="#features" className="btn btn-secondary">详细了解客番番</a>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section id="features" className="features-section">
        <h2 className="section-title">客番番海外客户开发优势</h2>
        <p className="section-subtitle">安全、高效、真实、售后无忧，让您用更少的人力成本，更高效地获取海外客户线索</p>

        <div className="features-grid">
          <div className="feature-card">
            <img src="/images/icon-1.png" alt="真机矩阵系统" />
            <h4>真机矩阵系统</h4>
            <p>突破虚拟机/模拟器的失真问题，保障账号稳定性与内容推荐权重</p>
          </div>

          <div className="feature-card">
            <img src="/images/icon-2.png" alt="高效社媒管理" />
            <h4>高效社媒管理</h4>
            <p>多平台、多账号矩阵登录，独立环境隔离运行，账号分组高效管理</p>
          </div>

          <div className="feature-card">
            <img src="/images/icon-3.png" alt="智能获客引擎" />
            <h4>智能获客引擎</h4>
            <p>借助RPA技术实现自动养号、批量点赞评论等一人可管理数百账号</p>
          </div>

          <div className="feature-card">
            <img src="/images/icon-4.png" alt="精准线索获取" />
            <h4>精准线索获取</h4>
            <p>30分钟采集10万+数据，结合主动引流与被动引流，优化获客策略</p>
          </div>

          <div className="feature-card">
            <img src="/images/icon-5.png" alt="安全稳定保障" />
            <h4>安全稳定保障</h4>
            <p>本地化存储敏感数据，杜绝云端泄漏风险，真实模拟降低账号风险</p>
          </div>
        </div>
      </section>

      {/* Service Section - 专职客户经理 */}
      <section className="service-section">
        <div className="service-content">
          <div className="service-left">
            <h1>专职客户经理</h1>
            <h1>一对一服务</h1>
            <p>助您最低成本地搭上智能获客这趟高速快车</p>
            <img src="/images/customer-service.jpg" alt="客户服务" />
          </div>

          <div className="service-right">
            <h1>你还在担心海外线索挖掘困难吗？</h1>
            <p>四大客户赋能，帮您玩转海外市场</p>

            <div className="accordion">
              <div className={`accordion-item ${activeAccordion === 0 ? 'active' : ''}`}>
                <div className="accordion-header" onClick={() => toggleAccordion(0)}>
                  <h4 className="accordion-title">矩阵思路分享</h4>
                  <span className="accordion-icon">{activeAccordion === 0 ? '−' : '›'}</span>
                </div>
                <div className="accordion-content">
                  <p>讲解矩阵思维，构建多维分析框架，结合实际案例，动态优化矩阵，助力高效决策。</p>
                </div>
              </div>

              <div className={`accordion-item ${activeAccordion === 1 ? 'active' : ''}`}>
                <div className="accordion-header" onClick={() => toggleAccordion(1)}>
                  <h4 className="accordion-title">AIGC玩法教学</h4>
                  <span className="accordion-icon">{activeAccordion === 1 ? '−' : '›'}</span>
                </div>
                <div className="accordion-content">
                  <p>介绍AIGC基础，实操热门工具，拓展创意玩法，分享行业应用案例，助力快速上手并激发创造力。</p>
                </div>
              </div>

              <div className={`accordion-item ${activeAccordion === 2 ? 'active' : ''}`}>
                <div className="accordion-header" onClick={() => toggleAccordion(2)}>
                  <h4 className="accordion-title">数据分析思维</h4>
                  <span className="accordion-icon">{activeAccordion === 2 ? '−' : '›'}</span>
                </div>
                <div className="accordion-content">
                  <p>强调数据驱动思维，涵盖数据收集整理、分析方法、可视化呈现，助力洞察趋势、提炼结论。</p>
                </div>
              </div>

              <div className={`accordion-item ${activeAccordion === 3 ? 'active' : ''}`}>
                <div className="accordion-header" onClick={() => toggleAccordion(3)}>
                  <h4 className="accordion-title">售后高速应答</h4>
                  <span className="accordion-icon">{activeAccordion === 3 ? '−' : '›'}</span>
                </div>
                <div className="accordion-content">
                  <p>通过优化团队、流程与技术手段，实现快速响应和高效问题解决，提升客户满意度。</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Cloud Solution Section */}
      <section className="cloud-section">
        <div className="cloud-content">
          <div className="cloud-text">
            <h1>低成本管理多平台多个社交媒体账号</h1>
            <p>充分利用平台对来自移动设备的操作赋予更高的信任和权重，确保在未来的数字生态中占据领先地位</p>
            <p className="highlight"><strong>云控技术解决方案</strong></p>
            <p className="highlight">硬件加软件，区别于传统云技术，更加真实有效</p>
            <p className="highlight">一次性付费，避免重复收费，帮助做好运营预算。</p>
            <a href="#contact" className="btn btn-primary">点击查看</a>
          </div>

          <div className="cloud-image">
            <img src="/images/cloud-solution.png" alt="云控解决方案" />
          </div>
        </div>
      </section>

      {/* Why Section */}
      <section className="why-section">
        <h2 className="section-title">为什么选择客番番？</h2>
        <div className="why-content">
          <div className="why-image">
            <img src="/images/why-us.png" alt="为什么选择客番番" />
          </div>
          <div className="why-text">
            <h2>为什么选择客番番？</h2>
            <p>在全球化的浪潮中，跨境电商和国际品牌需要强大的客户抓取工具来提升效率、降低成本，并快速获取精准客户。客番番，正是为此而生。</p>
            <ul>
              <li><b>全平台覆盖：</b>支持主流社交媒体平台（Facebook、TikTok、WhatsApp、Instagram、Telegram、Google等）。</li>
              <li><b>自动化营销：</b>RPA（机器人流程自动化），解放人力，高效触达客户，提升转化率。</li>
              <li><b>多语言支持：</b>实时翻译无障碍沟通，助您轻松跨越语言屏障。</li>
              <li><b>安全有保障：</b>AI环境隔离和硬件支持，确保多账号操作稳定性。</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Solutions Section */}
      <section className="features-section">
        <h2 className="section-title">客番番场景化解决方案</h2>
        <div className="solutions-grid">
          <div className="feature-card">
            <img src="/images/solution-1.png" alt="跨境电商" />
            <h2>跨境电商</h2>
            <p>TikTok小店全域引流</p>
            <p>Facebook群组裂变</p>
          </div>

          <div className="feature-card">
            <img src="/images/solution-2.png" alt="制造业出海" />
            <h2>制造业出海</h2>
            <p>全媒体B端客户开发</p>
            <p>谷歌地图B2B挖掘</p>
          </div>

          <div className="feature-card">
            <img src="/images/solution-3.png" alt="品牌国际化" />
            <h2>品牌国际化</h2>
            <p>Instagram品牌声量运营</p>
            <p>海外网红营销对接</p>
          </div>
        </div>
      </section>

      {/* Form Section */}
      <section id="contact" className="form-section">
        <div className="form-container">
          <h2>立即开启AI驱动的全球化增长！</h2>
          <p>填写表单，预约专属客户经理</p>

          <form onSubmit={handleSubmit}>
            <div className="form-grid">
              <div className="form-group">
                <label>姓名</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="请输入您的姓名"
                />
              </div>

              <div className="form-group">
                <label>联系方式</label>
                <input
                  type="text"
                  name="phoneWhatsapp"
                  required
                  value={formData.phoneWhatsapp}
                  minLength={5}
                  onChange={handleChange}
                  placeholder="请输入电话/微信/WS/TG/Line(至少一种)"
                />
              </div>

              <div className="form-group">
                <label>业务类型</label>
                <input
                  type="text"
                  name="businessType"
                  value={formData.businessType}
                  onChange={handleChange}
                  placeholder="例如：工厂、贸易公司、跨境电商等"
                />
              </div>

              <div className="form-group">
                <label>行业</label>
                <input
                  type="text"
                  required
                  name="industry"
                  value={formData.industry}
                  onChange={handleChange}
                  placeholder="例如：其它综合外贸品类、3C电子、服装等"
                />
              </div>

              <div className="form-group">
                <label>目标市场</label>
                <input
                  type="text"
                  required
                  name="targetMarket"
                  value={formData.targetMarket}
                  onChange={handleChange}
                  placeholder="例如：全球、欧美、东南亚等"
                />
              </div>

              <div className="form-group">
                <label>是否预约演示</label>
                <input
                  type="text"
                  name="needDemo"
                  value={formData.needDemo}
                  onChange={handleChange}
                  placeholder="是/否/待定"
                />
              </div>

              <div className="form-group">
                <label>社媒账号</label>
                <input
                  type="text"
                  name="socialAccount"
                  value={formData.socialAccount}
                  onChange={handleChange}
                  placeholder="例如：Tg：@username 或 微信：xxx"
                />
              </div>

              <div className="form-group">
                <label>您的痛点</label>
                <input
                  type="text"
                  name="painPoint"
                  value={formData.painPoint}
                  onChange={handleChange}
                  placeholder="例如：想智能化获客、广告太贵"
                />
              </div>
            </div>

            <button type="submit" className="submit-btn" disabled={submitting}>
              {submitting ? '提交中...' : '立即免费体验'}
            </button>

            {message.text && (
              <div className={`form-message ${message.type}`}>
                {message.text}
              </div>
            )}
          </form>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-logo">
            <img src="/images/logo.png" alt="客番番Logo" />
            <div>
              <img src="/images/qrcode.png" alt="二维码" style={{maxWidth: '100%'}} />
            </div>
            <p>让客番番成为您跨境获客的最佳伙伴！</p>
          </div>
        </div>
      </footer>

      {/* Floating Contact Sidebar */}
      <div className="floating-contact">
        <a href="tel:+17371287827" className="contact-icon-item phone" target="_blank" rel="noopener noreferrer">
          <FaPhone />
          <div className="contact-tooltip">电话：+17371287827</div>
        </a>

        <button
          type="button"
          className="contact-icon-item wechat"
          onClick={handleWechatCopy}
          aria-label="复制微信号 dzt1234hu"
        >
          <FaWeixin />
          <div className="contact-tooltip">微信：dzt1234hu（点击复制）</div>
        </button>

        <a href="https://t.me/JACKONL" className="contact-icon-item telegram" target="_blank" rel="noopener noreferrer">
          <FaTelegram />
          <div className="contact-tooltip">Telegram：@JACKONL</div>
        </a>

        <a href="https://wa.me/8618171034236" className="contact-icon-item whatsapp" target="_blank" rel="noopener noreferrer">
          <FaWhatsapp />
          <div className="contact-tooltip">WhatsApp：+8618171034236</div>
        </a>

        <a href="https://line.me/ti/p/L_YiKxC6Dm" className="contact-icon-item line" target="_blank" rel="noopener noreferrer">
          <FaLine />
          <div className="contact-tooltip">LINE：dzt666888</div>
        </a>
      </div>
    </div>
  );
}

export default App;
